/* inno-cursor.js — the crosshair reticle for NON-homepage pages (product, cart, blog, etc.).
   The homepage runs its own richer cursor inside inno-site.js; this is the same reticle, made
   self-contained: it injects its own markup + styles, eases toward the pointer, flips black↔white
   against whatever's beneath it, opens over interactive elements, pops on click, and drops the
   fast-flick ASCII trail. Desktop (fine pointer) only. */
(function () {
  'use strict';
  if (!window.matchMedia || !window.matchMedia('(pointer: fine)').matches) return;

  var css = document.createElement('style');
  css.textContent =
    'html.inno-cursor, html.inno-cursor * { cursor: none !important; }' +
    '#inno-cur{position:fixed;left:-100px;top:-100px;z-index:2147483200;pointer-events:none;opacity:0;transition:opacity .2s;--cur:#E8E4DC;--ring:rgba(10,10,10,.4);}' +
    '#inno-cur.cur-dark{--cur:#0a0a0a;--ring:rgba(232,228,220,.55);}' +
    '#inno-cur .in{position:absolute;transition:transform .3s cubic-bezier(.25,1,.5,1);}' +
    '#inno-cur .dot{position:absolute;width:4px;height:4px;left:-2px;top:-2px;border-radius:50%;background:var(--cur);box-shadow:0 0 0 1px var(--ring);transition:background .18s ease,box-shadow .18s ease;}' +
    '#inno-cur.hot .in{transform:scale(1.5);}' +
    '#inno-cur.clicking .in{transform:scale(1.9);transition:transform .13s cubic-bezier(.34,1.8,.5,1);}' +
    '#inno-cur.hot.clicking .in{transform:scale(2.8);}' +
    '.inno-trail{position:fixed;z-index:2147483190;pointer-events:none;transform:translate(-50%,-50%);font-family:"IBM Plex Mono",ui-monospace,monospace;font-size:13px;font-weight:500;color:#6E1420;animation:inno-cur-trail 1s ease forwards;}' +
    '@keyframes inno-cur-trail{0%{opacity:.85;transform:translate(-50%,-50%) scale(1);}100%{opacity:0;transform:translate(-50%,-50%) scale(.6);}}' +
    '@media (prefers-reduced-motion: reduce){.inno-trail{display:none;}}' +
    '@media (pointer: coarse){#inno-cur{display:none;}}';
  (document.head || document.documentElement).appendChild(css);

  var cur = document.createElement('div');
  cur.id = 'inno-cur';
  cur.setAttribute('aria-hidden', 'true');
  cur.innerHTML = '<div class="in"><span class="dot"></span></div>';

  function mount() {
    document.body.appendChild(cur);
    document.documentElement.classList.add('inno-cursor');
  }
  if (document.body) mount();
  else document.addEventListener('DOMContentLoaded', mount);

  var tx = -100, ty = -100, cx = -100, cy = -100, raf = 0;

  // ---- contrast: sample what's under the reticle and flip it black↔white ----
  var sc = document.createElement('canvas'), sctx = sc.getContext && sc.getContext('2d'), lastC = 0;
  function contrast(x, y) {
    var lum = 0.85;   // most inner pages are the bone/light surface → default to a dark reticle
    var els = document.elementsFromPoint(x, y);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.id === 'inno-cur' || (el.closest && el.closest('#inno-cur'))) continue;
      if (el.tagName === 'IMG' && el.naturalWidth && sctx) {
        try {
          var r = el.getBoundingClientRect();
          var rx = Math.min(0.999, Math.max(0, (x - r.left) / r.width));
          var ry = Math.min(0.999, Math.max(0, (y - r.top) / r.height));
          sc.width = sc.height = 1;
          sctx.drawImage(el, rx * el.naturalWidth, ry * el.naturalHeight, 1, 1, 0, 0, 1, 1);
          var d = sctx.getImageData(0, 0, 1, 1).data;
          lum = (0.2126 * d[0] + 0.7152 * d[1] + 0.0722 * d[2]) / 255;
        } catch (e) {}
        break;
      }
      if (el.tagName === 'CANVAS') { lum = 0.85; break; }   // the mesh canvases sit on the bone surface
      var bg = getComputedStyle(el).backgroundColor;
      var m = bg && bg.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?/);
      if (m && (m[4] === undefined || parseFloat(m[4]) > 0.3)) {
        lum = (0.2126 * +m[1] + 0.7152 * +m[2] + 0.0722 * +m[3]) / 255;
        break;
      }
    }
    cur.classList.toggle('cur-dark', lum > 0.5);
  }

  // ---- fast-flick ASCII trail ----
  var TR = '!<>-_\\/[]{}=+*^?#%&', lx = -1, ly = -1, lt = 0, ls = 0;
  function trail(x, y) {
    var s = document.createElement('span');
    s.className = 'inno-trail';
    s.textContent = TR[(Math.random() * TR.length) | 0];
    s.style.left = x + 'px'; s.style.top = y + 'px';
    document.body.appendChild(s);
    var f = 0, iv = setInterval(function () { s.textContent = TR[(Math.random() * TR.length) | 0]; if (++f > 6) clearInterval(iv); }, 70);
    setTimeout(function () { clearInterval(iv); if (s.parentNode) s.parentNode.removeChild(s); }, 1000);
  }

  var HOT = 'a,button,input,select,textarea,summary,label,[role=button],.hot,.inno-thumb,.pcell,[data-icd-close],[data-icd-remove]';
  window.addEventListener('mousemove', function (e) {
    tx = e.clientX; ty = e.clientY; cur.style.opacity = 1;
    var now = e.timeStamp;
    if (lx >= 0) {
      var dx = e.clientX - lx, dy = e.clientY - ly, dt = (now - lt) || 16;
      if (Math.hypot(dx, dy) / dt > 1.7 && now - ls > 55) { trail(e.clientX, e.clientY); ls = now; }
    }
    lx = e.clientX; ly = e.clientY; lt = now;
    if (now - lastC > 55) { lastC = now; contrast(e.clientX, e.clientY); }
    cur.classList.toggle('hot', !!(e.target.closest && e.target.closest(HOT)));
    if (!raf) raf = requestAnimationFrame(follow);
  });
  document.addEventListener('mouseleave', function () { cur.style.opacity = 0; });

  var clickHold;
  window.addEventListener('pointerdown', function () { cur.classList.add('clicking'); clearTimeout(clickHold); }, true);
  window.addEventListener('pointerup', function () { clearTimeout(clickHold); clickHold = setTimeout(function () { cur.classList.remove('clicking'); }, 160); }, true);
  window.addEventListener('pointercancel', function () { clearTimeout(clickHold); cur.classList.remove('clicking'); }, true);

  /* NO LAG. This used to ease toward the pointer at 0.16 a frame, which on anything quicker
     than a drift left the reticle visibly behind the hand — a cursor that cannot keep up stops
     reading as the cursor. It lands on the pointer now, so one frame settles it and there is
     nothing left to re-schedule. */
  function follow() {
    raf = 0;
    cx = tx; cy = ty;
    cur.style.left = cx + 'px'; cur.style.top = cy + 'px';
  }

  // Drive the reticle from outside. Needed while dragging the cart window: that handler owns the
  // pointer (capture + preventDefault), which suppresses the compatibility mousemove this file
  // listens to — without it the cursor froze while the window moved under it. `snap` is now the
  // same thing the ordinary path does; it stays because callers still pass it.
  window.innoCursorTo = function (x, y, snap) {
    tx = x; ty = y;
    cur.style.opacity = 1;
    if (snap) { cx = x; cy = y; cur.style.left = cx + 'px'; cur.style.top = cy + 'px'; return; }
    if (!raf) raf = requestAnimationFrame(follow);
  };
})();
